

import axios from 'axios';

const API_KEY = process.env.REACT_APP_GMAP_API

 const checkRailConnectivity = async (origin, destination) => {
  const url = `https://maps.googleapis.com/maps/api/directions/json?origin=${origin}&destination=${destination}&mode=transit&transit_mode=train&key=${API_KEY}`;
  try {
    const response = await axios.get(url);
    // console.log("-----response from google api-----",response,
    //   "\nresponse.status: ",response.status,"\nresponse.data",response.data
    // )
    if (response.status === 200 && response.data) {
      const hasRail = response.data.routes.some(route =>
        route.legs.some(leg =>
          leg.steps.some(step => step.travel_mode === 'TRANSIT' && step.transit_details?.line?.vehicle?.type?.includes('RAIL'))
        )
      );

      const hasDrivingRoute = response.data?.available_travel_modes?.includes("DRIVING")
  
      // console.log("----hasRail: ",hasRail,"--hasDrivingRoute---",hasDrivingRoute)
      return hasRail ? 'RAIL' : (hasDrivingRoute ? 'TRUCK' : 'VESSEL');
    } else {
      return 'No Rail Route Found';
    }
  } catch (error) {
    return 'Error fetching data. Please try again.';
  }
}

export const classifyScheduleTransportMode = async (route) => {
  //console.log(".....classifyLegTransportMode is executing.......",route)
  const originPlace = route?.fromPoint?.location?.name
  const destinationPlace = route?.toPoint?.location?.name
  //console.log("originPlace: ",originPlace,"\ndestinationPlace: ",destinationPlace)
  const res = await checkRailConnectivity(originPlace, destinationPlace);
  // console.log("-----res--------",res)
  return res
}
